<template>
  <div class="new-page-con">
    <Header @onSearch="onSearch">
      <!-- 工具栏 -->
      <Tollbar
        :list="tollbarList"
        :sortList="sortList"
        :conditionsList="conditionsList"
        :selectList="selectList"
        type="2"
        theme="1"
        :isShowSearch.sync="isShowSearch"
        :isShowSelect.sync="isShowSelect"
        @onClearSearch="onClearSearch"
        @onChangeSort="onChangeSort"
      ></Tollbar>
    </Header>
    <div class="new-content-con">
      <!-- 检索条件 -->
      <div
        class="new-search-con"
        :class="{ 'new-content-none-search': !isShowSearch }"
      >
        <span class="clear-search-icon Clear_All" @click="onClearSearch"
          ><i class="iconfont icon-qingchu"></i> Clear All
        </span>
        <el-form
          ref="searchForm"
          label-position="top"
          :model="searchForm"
          class="new-content-search"
        >
          <!-- 名称   -->
          <el-form-item label="Name" prop="termId">
            <el-input
              class="search-select-con"
              placeholder="Search Person Name"
              v-model="searchForm.termId"
            >
              <i
                slot="suffix"
                style="cursor: pointer"
                @click="onChangeParams(searchForm.termId, 'Name')"
                class="el-input__icon el-icon-search"
              ></i>
            </el-input>
          </el-form-item>
          <!-- 国家 -->
          <el-form-item
            label="Country"
            prop="termCountry"
            v-if="this.$route.query.keyword"
          >
            <el-select
              clearable
              key="Country"
              v-model="searchForm.termCountry"
              filterable
              :disabled="!this.$route.query.keyword"
              class="search-select-con"
              popper-class="new-search-select"
              :popper-append-to-body="false"
              placeholder="Select Country"
              remote
              :remote-method="countryMethod"
              @change="(val) => onChangeParams(val, 'Country')"
              @visible-change="onFocusCountry"
            >
              <el-option
                v-for="(item, index) in countryList"
                :key="index"
                :label="item.name"
                :value="item.id"
              >
                <div class="flex-between-center">
                  <el-tooltip
                    effect="light"
                    :visible-arrow="false"
                    :disabled="item?.name?.length < 25"
                    :content="item.name"
                    placement="right"
                  >
                    <span class="select-name">{{ item.name }}</span>
                  </el-tooltip>
                </div>
              </el-option>
            </el-select>
          </el-form-item>
          <!-- 日期 -->
          <el-form-item label="DOB" prop="termBornDate">
            <el-select
              clearable
              key="BronDate"
              v-model="searchForm.termBornDate"
              filterable
              class="search-select-con"
              popper-class="new-search-select"
              :popper-append-to-body="false"
              placeholder="Select DOB"
              remote
              :remote-method="dateMethod"
              @change="onChangeParams"
              @visible-change="onFocusDate"
            >
              <el-option
                v-for="(item, index) in dateList"
                :key="index"
                :label="item.name"
                :value="item.id"
              >
                <div class="flex-between-center">
                  <span class="select-name">{{ item.name }}</span>
                </div>
              </el-option>
            </el-select>
          </el-form-item>
          <!-- 性别 -->
          <el-form-item label="Gender" prop="termGender">
            <el-radio-group
              v-model="searchForm.termGender"
              @change="onChangeParams"
            >
              <el-radio
                v-for="item in genderList"
                :key="item.dictDataCode"
                :label="item.dictDataCode"
              >
                {{ item.dictDataName }}
              </el-radio>
            </el-radio-group>
          </el-form-item>
          <!-- 信息来源 -->
          <el-form-item label="Record Source" prop="termInformationSource">
            <el-select
              clearable
              key="Sources"
              v-model="searchForm.termInformationSource"
              filterable
              class="search-select-con"
              popper-class="new-search-select"
              :popper-append-to-body="false"
              placeholder="Select Record Source"
              remote
              :remote-method="informationMethod"
              @change="(val) => onChangeParams(val, 'Sources')"
              @visible-change="onFocusInformation"
            >
              <el-option
                v-for="(item, index) in sourceList"
                :key="index"
                :label="item.name"
                :value="item.id"
              >
                <div class="flex-between-center">
                  <el-tooltip
                    effect="light"
                    :visible-arrow="false"
                    :disabled="item?.name?.length < 25"
                    :content="item.name"
                    placement="right"
                  >
                    <span class="select-name">{{ item.name }}</span>
                  </el-tooltip>
                </div>
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>

      <!-- 列表 -->
      <div class="new-content-right">
        <div class="new-content-total">
          Found over {{ totalCount | FilterNum }}
          <span v-if="$route.query.keyword">"{{ $route.query.keyword }}"</span>
          results
        </div>
        <div class="new-table-box" v-loading="loading">
          <el-table
            :data="tableData"
            row-key="id"
            class="new-table-con"
            height="100%"
            v-loadmore="handleScroll"
            @selection-change="onChangeSelection"
          >
            <el-table-column
              type="selection"
              reserve-selection
              :width="isShowSelect ? 40 : 10"
              align="right"
            >
            </el-table-column>
            <el-table-column
              prop="personName"
              label="Name"
              min-width="200"
              class-name="hover-cell"
              show-overflow-tooltip
            >
              <template slot="header" slot-scope="scope">
                <span
                  class="flex_center_start_box"
                  style="font-family: 'Arial Bold'"
                  >Name
                  <el-tooltip
                    effect="dark"
                    content="translation"
                    placement="top"
                  >
                    <svg
                      t="1745228136270"
                      @click="cangeLang"
                      style="margin-left: 10px"
                      class="icon"
                      viewBox="0 0 1024 1024"
                      version="1.1"
                      xmlns="http://www.w3.org/2000/svg"
                      p-id="6240"
                      width="25"
                      height="25"
                    >
                      <path
                        d="M181.333333 462.741333h660.672a32 32 0 1 0 0-64H181.333333a32 32 0 0 0 0 64M388.650667 786.837333L203.946667 602.154667a32 32 0 1 0-45.248 45.248l184.682666 184.682666a32 32 0 1 0 45.248-45.248"
                        p-id="6241"
                        fill="#F9722C"
                      ></path>
                      <path
                        d="M634.709333 267.946667l184.682667 184.704a32 32 0 1 0 45.248-45.248l-184.682667-184.682667a32 32 0 1 0-45.248 45.248M842.026667 592.042667H181.333333a32 32 0 1 0 0 64h660.693334a32 32 0 0 0 0-64"
                        p-id="6242"
                        fill="#F9722C"
                      ></path>
                    </svg>
                  </el-tooltip>
                </span>
              </template>
              <template slot-scope="scope">
                <span
                  class="link-text hover-text"
                  @click="onGoPage(scope.row)"
                  >{{
                    isLangEN
                      ? scope.row?.personName
                        ? scope.row?.personName
                        : "-"
                      : scope.row?.personNameNative
                      ? scope.row?.personNameNative
                      : "-"
                  }}</span
                >
              </template>
            </el-table-column>
            <el-table-column
              prop="countryName"
              label="Country"
              width="250"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                {{ scope.row?.countryName ? scope.row.countryName : "-" }}
              </template>
            </el-table-column>
            <el-table-column
              prop="bornDate"
              label="DOB"
              width="150"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                {{ scope.row?.bornDate ? scope.row.bornDate : "-" }}
              </template>
            </el-table-column>
            <el-table-column
              prop="gender"
              label="Gender"
              width="120"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                {{ scope.row?.gender ? scope.row.gender : "-" }}
              </template>
            </el-table-column>
            <el-table-column
              prop="informationSource"
              label="Record Source"
              min-width="270"
              class-name="two-column-cell"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                {{
                  scope.row?.informationSource
                    ? scope.row.informationSource
                    : "-"
                }}
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Header from "@/views/newLayout/header.vue";
import Tollbar from "@/views/newLayout/tollbar.vue";
import {
  searchSanctionList,
  getCpSanctionSelectOptions,
  getSanctionPersonInfo,
} from "@/api/newApi.js";
export default {
  directives: {
    loadmore: {
      bind(el, binding) {
        const selectWrap = el.querySelector(".el-table__body-wrapper");
        selectWrap.addEventListener("scroll", function () {
          const scrollDistance =
            this.scrollHeight - this.scrollTop - this.clientHeight;
          if (scrollDistance <= 0.5) {
            binding.value(); // 执行绑定的函数
          }
        });
      },
    },
  },
  components: {
    Header,
    Tollbar,
  },
  watch: {
    isShowSearch: {
      handler(newVal) {
        this.isShowSearch = newVal;
      },
      deep: true,
      immediate: true,
    },
    isShowSelect: {
      handler(newVal) {
        this.isShowSelect = newVal;
      },
      deep: true,
      immediate: true,
    },
  },
  data() {
    return {
      isLangEN: true,
      tollbarList: [
        {
          icon: "icon-youhua",
          name: "Optimize",
          disabled: true,
        },
        {
          icon: "icon-xuanze",
          name: "Select",
          disabled: true,
        },
        {
          icon: "icon-bianji1",
          name: "Edit",
          disabled: true,
          select: true,
        },
        {
          icon: "icon-filter",
          name: "Sort by",
          disabled: false,
          select: true,
        },
        {
          icon: "icon-shoucang1",
          name: "Collect",
          disabled: true,
          select: true,
        },
        {
          icon: "icon-baocun",
          name: "Saved",
          disabled: true,
          select: true,
        },
        {
          icon: "icon-icon_xinyong_xianxing_jijin-307",
          name: "Compare",
          disabled: true,
        },
        {
          icon: "icon-daochu04",
          name: "Export",
          disabled: true,
        },
        {
          icon: "icon-xiazai",
          name: "Download",
          disabled: true,
        },
        {
          icon: "icon-shuaxin",
          name: "Update",
          disabled: true,
        },
        {
          icon: "icon-judan",
          name: "Report Error",
          disabled: true,
        },
        {
          icon: "icon-gudong",
          name: "Share",
          disabled: true,
        },
      ],
      sortList: [
        {
          value: "",
          label: "Default",
        },
        {
          value: "1",
          label: "Ascending",
        },
        {
          value: "2",
          label: "Descending",
        },
      ],
      conditionsList: [
        "Name",
        "Country",
        "Birthday Date",
        "Gender",
        "Information Sources",
      ],
      searchForm: {
        termId: "", //精确用
        name: "", //头部用
        termCountry: "",
        termBornDate: "",
        termGender: "", //1男2女
        termInformationSource: "",
        sortBy: "",
      },
      searchName: "",
      searchCountry: "",
      searchSource: "",
      dateList: [],
      nameList: [],
      countryList: [],
      genderList: [
        {
          dictDataCode: "",
          dictDataName: "All",
        },
        {
          dictDataCode: "1",
          dictDataName: "Male",
        },
        {
          dictDataCode: "2",
          dictDataName: "Female",
        },
        {
          dictDataCode: "3",
          dictDataName: "Other",
        },
      ],
      sourceList: [],
      tableData: [], // 表格数据
      personInfo: {
        email: null,
        location: null,
        nameCn: null,
        nameEn: null,
        phone: null,
        relations: 0,
        roles: null,
      }, //人的详情信息
      isShowSearch: true,
      isShowSelect: false, // 是否显示复选框
      selectList: [],
      params: {
        page: 1, // 当前页数
        pageSize: 100, // 每页加载的数据条数
      },
      totalCount: 0,
      loading: false, // 加载状态
      hasMore: true, // 是否还有更多数据
    };
  },
  methods: {
    // 切换本地语言
    cangeLang() {
      this.isLangEN = !this.isLangEN;
    },
    // 搜索
    onSearch(params) {
      this.searchForm.termCountry = "";
      this.searchForm.termId = "";
      this.searchForm.termBornDate = "";
      this.searchForm.termGender = "";
      this.searchForm.termInformationSource = "";
      // 调用检索api
      if (params.selectCode == 1) {
        // 公司
        this.$router.push({
          path: "/sanction/companyList",
          query: {
            selectCode: 1,
            keyword: params.searchKeyword,
          },
        });
      } else if (params.selectCode == 2) {
        // 个人本身
        // 参数不同时进行路由替换，否则会报错
        if (params.searchKeyword != this.$route.query.keyword) {
          this.$store.dispatch("app/SetlabelCode", "");
          this.$store.dispatch("app/SetlabelCodeName", "");
          this.$store.dispatch("app/SetarchagAin", true);
          this.$store.commit("setRefreshKey", new Date().getTime());
          this.$router.replace({
            path: "/sanction/personList",
            query: {
              selectCode: 2,
              keyword: params.searchKeyword,
            },
          });
        }
        // 调用检索api
        if (this.$route.query.keyword) {
          this.params.page = 1;
          this.searchForm.name = this.$route.query.keyword;
          this.tableData = [];
          this.getSearchList();
        }
      } else if (params.selectCode == 3) {
        // 产品
        this.$router.push({
          path: "/sanction/productList",
          query: {
            selectCode: 3,
            keyword: params.searchKeyword,
          },
        });
      } else {
        // 国家
        this.$router.push({
          path: "/sanction/countryList",
          query: {
            selectCode: 4,
            keyword: params.searchKeyword,
            CountryCode: params.CountryCode,
          },
        });
      }
    },
    // 名字搜索
    async nameMethod(query) {
      if (query == "") {
        this.nameList = [];
        return;
      }
      this.searchForm.termCountry = this.keyword
        ? this.searchForm.termCountry
        : this.$route.query.TargetCountryCode;
      let res = await getCpSanctionSelectOptions({
        name: this.$route.query.keyword,
        optionType: 1,
        companyOrPerson: 2,
        aggregationsKeyWord: query,
        termId: "",
        termCountry: this.searchForm.termCountry,
        termGender: this.searchForm.termGender,
        termInformationSource: this.searchForm.termInformationSource,
        termBornDate: this.searchForm.termBornDate,
        sourceType: this.$route.query.keyword ? 1 : 2,
        targetCountry: this.$route.query.keyword
          ? ""
          : this.$route.query.CountryCode,
      });
      this.nameList = res?.data?.options || [];
    },
    // 名称聚焦
    onFocusName(val) {
      this.nameList = [];
      if (val && !!this.searchName) {
        this.getSanctionOptions(this.searchName, 1);
      }
    },
    // 国家搜索
    async countryMethod(query) {
      let res = await getCpSanctionSelectOptions({
        name: this.$route.query.keyword,
        optionType: 2,
        companyOrPerson: 2,
        aggregationsKeyWord: query,
        termId: this.searchForm.termId,
        termCountry: "",
        termGender: this.searchForm.termGender,
        termInformationSource: this.searchForm.termInformationSource,
        termBornDate: this.searchForm.termBornDate,
        sourceType: this.$route.query.keyword ? 1 : 2,
        targetCountry: this.$route.query.keyword
          ? ""
          : this.$route.query.CountryCode,
      });
      this.countryList = res?.data?.options || [];
      this.countryList = this.countryList.filter((item) => item.name != "");
    },
    // 国家聚焦时
    onFocusCountry(val) {
      if (val) {
        this.getSanctionOptions(this.searchCountry, 2);
      }
    },
    // 信息来源搜索
    async informationMethod(query) {
      this.searchForm.termCountry = this.$route.query.keyword
        ? this.searchForm.termCountry
        : this.$route.query.TargetCountryCode;
      let res = await getCpSanctionSelectOptions({
        name: this.$route.query.keyword,
        optionType: 3,
        companyOrPerson: 2,
        aggregationsKeyWord: query,
        termId: this.searchForm.termId,
        termCountry: this.searchForm.termCountry,
        termGender: this.searchForm.termGender,
        termInformationSource: "",
        termBornDate: this.searchForm.termBornDate,
        sourceType: this.$route.query.keyword ? 1 : 2,
        targetCountry: this.$route.query.keyword
          ? ""
          : this.$route.query.CountryCode,
      });
      this.sourceList = res?.data?.options || [];
    },
    // 信息来源聚焦时
    onFocusInformation(val) {
      if (val) {
        this.getSanctionOptions(this.searchSource, 3);
      }
    },
    // 时间搜索
    async dateMethod(query) {
      this.searchForm.termCountry = this.$route.query.keyword
        ? this.searchForm.termCountry
        : this.$route.query.TargetCountryCode;
      let res = await getCpSanctionSelectOptions({
        name: this.$route.query.keyword,
        optionType: 4,
        companyOrPerson: 2,
        aggregationsKeyWord: query,
        termId: this.searchForm.termId,
        termCountry: this.searchForm.termCountry,
        termGender: this.searchForm.termGender,
        termInformationSource: this.searchForm.termInformationSource,
        termBornDate: "",
        sourceType: this.$route.query.keyword ? 1 : 2,
        targetCountry: this.$route.query.keyword
          ? ""
          : this.$route.query.CountryCode,
      });
      this.dateList = res?.data?.options || [];
    },
    // 时间聚焦时
    onFocusDate(val) {
      if (val) {
        this.getSanctionOptions(this.searchForm.termBornDate, 4);
      }
    },
    async getSanctionOptions(val, type) {
      this.searchForm.termCountry = this.$route.query.keyword
        ? this.searchForm.termCountry
        : this.$route.query.TargetCountryCode;
      let res = await getCpSanctionSelectOptions({
        name: this.$route.query.keyword,
        optionType: type,
        companyOrPerson: 2,
        aggregationsKeyWord: val,
        termId: this.searchForm.termId,
        termCountry: this.searchForm.termCountry,
        termGender: this.searchForm.termGender,
        termInformationSource: this.searchForm.termInformationSource,
        termBornDate: this.searchForm.termBornDate,
        sourceType: this.$route.query.keyword ? 1 : 2,
        targetCountry: this.$route.query.keyword
          ? ""
          : this.$route.query.CountryCode,
      });
      if (type == 1) {
        // 名称
        this.nameList = res?.data?.options || [];
      }
      if (type == 2) {
        // 国家
        this.countryList = res?.data?.options || [];
        this.countryList = this.countryList.filter((item) => item.name != "");
      }
      if (type == 3) {
        // 信息源
        this.sourceList = res?.data?.options || [];
      }
      if (type == 4) {
        // 出生年份
        this.dateList = res?.data?.options || [];
      }
    },
    // 参数改变时
    onChangeParams(val, key) {
      if (key == "Name") {
        // 名称
        this.searchName = this.nameList.filter(
          (item) => item.id == this.searchForm.termId,
        )[0]?.name;
      }
      if (key == "Country") {
        // 国家
        this.searchCountry = this.countryList.filter(
          (item) => item.id == this.searchForm.termCountry,
        )[0]?.name;
      }
      if (key == "Sources") {
        // 来源
        this.searchSource = this.sourceList.filter(
          (item) => item.id == this.searchForm.termInformationSource,
        )[0]?.name;
      }
      this.params.page = 1;
      this.tableData = [];

      this.getSearchList();
    },

    // 获取一览列表
    async getSearchList() {
      this.loading = true;

      this.searchForm.termCountry = this.$route.query.keyword
        ? this.searchForm.termCountry
        : this.$route.query.TargetCountryCode;
      this.loading = true;
      let res = await searchSanctionList({
        page: this.params.page,
        pageSize: this.params.pageSize,
        ...this.searchForm,
        companyOrPerson: 2,
        sourceType: this.$route.query.keyword ? 1 : 2,
        targetCountry: this.$route.query.keyword
          ? ""
          : this.$route.query.CountryCode,
      });

      // 将新数据添加到现有数据
      if (res.code == 200) {
        this.hasMore = true;
        if (this.$route.query.keyword) {
          this.totalCount = res.data?.total;
        } else {
          if (
            this.searchForm.termId ||
            this.searchForm.termBornDate ||
            this.searchForm.termGender
          ) {
            this.totalCount = res.data?.total;
          } else {
            this.totalCount = this.$route.query.totle;
          }
        }
        res.data.rows = res?.data?.rows ? res?.data?.rows : [];
        this.tableData = [...this.tableData, ...res?.data?.rows];
      }
      this.loading = false;
    },
    // 获取人详情信息
    async getPersonInfo(row) {
      this.personInfo = {
        email: null,
        location: null,
        nameCn: null,
        nameEn: null,
        phone: null,
        relations: 0,
        roles: null,
      };
      let res = await getSanctionPersonInfo({
        id: row.id,
      });
      if (res.code == 200) {
        this.personInfo = res.data;
      } else {
        this.personInfo = {
          email: null,
          location: null,
          nameCn: null,
          nameEn: null,
          phone: null,
          relations: 0,
          roles: null,
        };
      }
    },
    onChangeSelection(val) {
      this.selectList = val;
    },
    // 清空检索条件
    onClearSearch() {
      this.$refs["searchForm"].resetFields();
      this.searchName = "";
      this.searchCountry = "";
      this.searchSource = "";
      this.params.page = 1;
      this.searchForm.name = this.$route.query.keyword;
      this.searchForm.termCountry = "";
      this.tableData = [];
      this.getSearchList();
    },
    // 清空排序
    onChangeSort(e) {
      this.searchForm.sortBy = e.length > 0 ? e[0] : "";
      // if (this.$route.query.keyword) {
      this.params.page = 1;
      this.tableData = [];
      this.getSearchList();
      // }
    },
    // 表格滚动
    handleScroll() {
      if (this.hasMore && !this.loading) {
        this.loadData();
      }
    },
    // 加载数据
    loadData() {
      let totalPage = Math.ceil(this.totalCount / this.params.pageSize);
      if (this.params.page == totalPage) {
        this.hasMore = false;
      } else {
        this.params.page += 1;
        this.getSearchList();
      }
    },
    onGoPage(row) {
      let routeData = this.$router.resolve({
        path: "/sanction/personDetail/sanction",
        query: {
          id: row.id,
          keyword: this.$route.query.keyword,
          selectCode: 2,
        },
      });
      window.open(routeData.href, "_blank");
    },
  },
  mounted() {
    // if (this.$route.query.keyword) {
    this.params.page = 1;
    this.searchForm.name = this.$route.query.keyword;
    this.tableData = [];
    const token = localStorage.getItem("token");
    if (token) {
      this.getSearchList();
    }
    // }
  },
};
</script>
<style scoped>
.person-popper-con-title {
  position: relative;
  display: inline-block;
  width: auto;
  height: 28px;
  line-height: 28px;
  margin-bottom: 28px;
}
.person-popper-con-title::after {
  content: "";
  position: absolute;
  top: 30px; /* 28 + 2 * 1 */
  left: 0;
  width: 100%;
  height: 2px;
  background: #f9722c;
}
.person-popper-con-title-eng {
  position: relative;
  display: inline-block;
  margin-right: 6px;
  font-family: "Arial Bold";
  font-size: 24px;
  color: #f9722c;
  vertical-align: top;
}
.person-popper-con-title-eng::after {
  content: "";
  position: absolute;
  top: 34px; /* 28 + 2 * 3 */
  left: 0;
  width: 100%;
  height: 2px;
  background: #f9722c;
}
.person-popper-con-title-ch {
  display: inline-block;
  font-family: "Arial Bold";
  font-size: 18px;
  color: #1a2332;
  vertical-align: top;
}
.person-popper-con-list-item {
  display: flex;
  height: 24px;
  line-height: 24px;
  margin-bottom: 12px;
}
.person-popper-con-list-item:last-child {
  margin-bottom: 0;
}
.person-popper-con-list-item-name {
  width: 80px;
  margin-right: 10px;
  font-size: 18px;
  color: #666666;
}
.person-popper-con-list-item-val {
  width: calc(100% - 90px);
  font-size: 18px;
  color: #1a2332;
}
.new-content-search >>> .el-radio-group {
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 20px;
}
@media (max-width: 1680px) {
  .person-popper-con-title {
    height: 19px;
    line-height: 19px;
    margin-bottom: 18px;
  }
  .person-popper-con-title::after {
    top: 20px; /* 19 + 1 * 1 */
    height: 1px;
  }
  .person-popper-con-title-eng {
    margin-right: 4px;
    font-size: 16px;
  }
  .person-popper-con-title-eng::after {
    top: 22px; /* 19 + 1 * 3 */
    height: 1px;
  }
  .person-popper-con-title-ch {
    font-size: 14px;
  }
  .person-popper-con-list-item {
    height: 18px;
    line-height: 18px;
    margin-bottom: 8px;
  }
  .person-popper-con-list-item-name {
    width: 64px;
    margin-right: 6px;
    font-size: 14px;
  }
  .person-popper-con-list-item-val {
    width: calc(100% - 70px);
    font-size: 14px;
  }
}

@media (max-width: 1920px) {
  .new-content-search >>> .el-radio-group {
    gap: 14px;
  }

  ::v-deep .new-content-search .el-form-item__label {
    font-size: 16px;
    margin-bottom: 7px;
  }

  ::v-deep .new-content-search {
    padding: 0px;
  }

  ::v-deep .new-content-search .el-input__inner {
    height: 32px !important;
    font-size: 14px !important;
  }

  .el-input__inner {
    padding: 0 23px 0 7px;
    border-radius: 7px;
  }

  .new-search-select .el-select-dropdown__item {
    height: 32px;
    line-height: 32px;
    padding: 0 8px 0 14px;
    font-size: 14px !important;
  }
  ::v-deep .new-content-search .el-radio__label {
    font-size: 14px;
  }
  .iconfont {
    font-family: "iconfont" !important;
    font-size: 16px;
  }
  .Clear_All {
    font-size: 14px;
  }

  .new-content-country-right .new-content-right {
    width: 100%;
  }
  .new-content-sanction-con {
    width: 100%;
  }
  .new-content-right {
    padding: 0px;
  }
  .new-content-con {
    padding: 15px;
  }
  .new-search-con {
    width: 300px;
  }
  .new-content-right {
    width: calc(100% - 300px);
    padding: 15px;
    margin-left: 8px;
    background: #ffffff;
  }
  ::v-deep .clear-search-icon {
    right: 5px;
  }
}
</style>
